import { render, staticRenderFns } from "./MostInvalidRounds.vue?vue&type=template&id=4a97c253&scoped=true"
import script from "../../../scripts/partials/dashboard-charts/MostInvalidRounds.js?vue&type=script&lang=js&external"
export * from "../../../scripts/partials/dashboard-charts/MostInvalidRounds.js?vue&type=script&lang=js&external"
import style0 from "./MostInvalidRounds.vue?vue&type=style&index=0&id=4a97c253&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a97c253",
  null
  
)

export default component.exports